import { useContext } from "react";
import { AnalyticsContext } from "../../../store/analyticsS";
import { HotelContext } from "../../../store/hotel";
import LoadingBookings from "../../common/LoadingBookings";
import AccountGraph from "../../graph/accounts/accountGraph";
import SingleHotelAccountViewer from "../component/SingleHotelAccountViewer";
import CustomDateRangePicker from "../../analytics/components/DateRangePicker";
import Constant from "../../../constant/Constant";

const CollectionsScreen = () => {
  const analyticsContext = useContext(AnalyticsContext);
  const hotelContext = useContext(HotelContext);
  let collectionAnalytics = analyticsContext.collectionAnalytics;
  let allHotels = Object.keys(collectionAnalytics);

  const dateContent = (
    <div style={{ position: "absolute", top: "15px", left: "30px", zIndex: 4 }}>
      <CustomDateRangePicker
        startDay={hotelContext.startDay}
        days={hotelContext.days}
        onDateChange={(date, days) => {
          hotelContext.onUpdateDate(date, days);
        }}
      />
    </div>
  );

  if (
    analyticsContext.isCollectionAnalyticsLoading ||
    !analyticsContext.isCollectionAnalyticsLoaded
  ) {
    return (
      <>
        {dateContent}
        <LoadingBookings />
      </>
    );
  }

  return (
    <>
      {dateContent}
      {allHotels.length > 0 && (
        <AccountGraph
          analytics={collectionAnalytics}
          title="Collection Analytics"
          allOptions={Constant.CollectionAnalyticsShort}
          isTablularData={analyticsContext.isTabularData}
          onToggleTabularData={() => {
            analyticsContext.onToggleTabularData();
          }}
          isBar={analyticsContext.isBar}
          isHotel={analyticsContext.isHotel}
          isDate={analyticsContext.isDate}
          isPercentage={analyticsContext.isPercentage}
          onTogglePercentage={() => {
            analyticsContext.onTogglePercentage();
          }}
          onToggleBar={() => {
            analyticsContext.onToggleBar();
          }}
          onToggleHotel={() => {
            analyticsContext.onToggleHotel();
          }}
          onToggleDate={() => {
            analyticsContext.onToggleDate();
          }}
        />
      )}

      {!analyticsContext.isTabularData &&
        allHotels.map((hotel) => {
          return (
            <SingleHotelAccountViewer
              key={hotel}
              hotelName={hotel}
              allDateData={collectionAnalytics[hotel]}
              types={Constant.CollectionAnalyticsShort}
            />
          );
        })}
    </>
  );
};

export default CollectionsScreen;
